import type {AddExpedientResponsibleFormPayload} from "./add-expedient-responsible.schema";
import {AddExpedientResponsibleBody} from "@project/sdk/sales/zod";
import {addExpedientResponsible} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientKeys, expedientMutationKeys} from "../../../../../expedient-keys";

export function addExpedientResponsibleMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: expedientMutationKeys.addExpedientResponsible,
    mutationFn: (payload: AddExpedientResponsibleFormPayload) =>
      addExpedientResponsible(id, AddExpedientResponsibleBody.parse(payload)),
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: expedientKeys.detail(id)}),
        client.invalidateQueries({queryKey: expedientKeys.lists()}),
      ]);
    },
  });
}
